/** Where the resume service is, under the API's origin. */

export const RESUME_BASE = "/v1/resume";
